import * as Modules from './module-registry';

function setupModules(): void {
  for (const setup of Object.values(Modules)) {
    setup();
  }
}

export { setupModules };
